export default customElements.define('w-message', class Message extends wealthify.CustomElementBaseClass {

    constructor() {
        const styleSelector = 'c-message';
        const config = {
            styleSelector,
            templateHTML: `<strong class="${styleSelector}__container" aria-live="polite" data-root></strong>`
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);
        };
    }

    static get validTypes () {
        return [ 'error', 'success', 'warning' ];
    }

    static get observedProps () {
        return [
            new wealthify.Prop('label'),
            new wealthify.Prop('type', {
                default: 'error',
                type: wealthify.propTypes.ArrayItem(this.validTypes)
            })
        ];
    }

    get propCallbacks() {
        return {
            label: (value) => {
                this.dom.root.textContent = value;
            },
            type: (value) => {
                this.constructor.validTypes.forEach((key) => this.dom.root.classList.remove(`${this.styleSelector}__container--${key}`));
                this.dom.root.classList.add(`${this.styleSelector}__container--${value}`);
            }
        };
    }
});